import React from 'react';
import { BiographicalSearchDto } from '@app/api2/api';
import { Formik, Form, useFormikContext } from 'formik';
import { Button, Icon, Form as SForm } from 'semantic-ui-react';
import { SEARCH_TYPES_NAMES } from '../../types';
import { BiographicalSearchSchema } from './BiographicalForm.Schema';
import SemanticFormikInput from '@app/components/React/Common/Forms/SemanticFormikInput';
import { FormWithButtons } from './FormWithButtons';
import { ChangeObserver } from '@app/components/React/Labs/ChangeObserver';

interface Props {
  currentParams: BiographicalSearchDto;
  setCurrentParams: (p: BiographicalSearchDto) => void;
  onChange?: (params: BiographicalSearchDto) => void;
}

export default function BiographicalForm({ currentParams, setCurrentParams, onChange }: Props) {
  const discriminator = SEARCH_TYPES_NAMES.BiographicalSearchDto;

  const initialValues: BiographicalSearchDto = {
    discriminator,
    operator: currentParams.operator,
    firstName: currentParams.firstName || '',
    lastName: currentParams.lastName || '',
    dateOfBirth: currentParams.dateOfBirth,
  };

  const handleSubmit = (values: BiographicalSearchDto, helpers) => {
    setCurrentParams({ ...values, discriminator });
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={BiographicalSearchSchema}
      onSubmit={handleSubmit}
      validateOnBlur={false}
      validateOnChange={false}
      enableReinitialize
    >
      {({ handleSubmit, values }) => {
        return (
          <>
            <ChangeObserver value={values} onChange={onChange} />

            <FormWithButtons handleSubmit={handleSubmit}>
              <SForm.Group widths="equal">
                <SemanticFormikInput
                  name="firstName"
                  label="First Name"
                  placeholder="Enter first name"
                />
                <SemanticFormikInput
                  name="lastName"
                  label="Last Name"
                  placeholder="Enter last name"
                />
                <SemanticFormikInput
                  name="dateOfBirth"
                  label="Date of Birth"
                  type="date"
                />
              </SForm.Group>
            </FormWithButtons>
          </>
        );
      }}
    </Formik>
  );
}

